// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"17":"ViewSale","94":"Login","220":"create-debtor","351":"float","472":"settings","693":"salesRecords","930":"setup"}[chunkId] || chunkId) + "-legacy." + {"17":"9ed83114","94":"1f15bbd6","220":"bea691be","243":"50c12b38","351":"13b4dbf0","472":"3c5ddaba","693":"fd03964b","930":"407207cb"}[chunkId] + ".js";
};